import { render } from "./UQConfigStep.vue?vue&type=template&id=171060a4"
import script from "./UQConfigStep.vue?vue&type=script&lang=js"
export * from "./UQConfigStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__